import { render, staticRenderFns } from "./AddSource.vue?vue&type=template&id=fd353562&scoped=true&"
import script from "./AddSource.vue?vue&type=script&lang=js&"
export * from "./AddSource.vue?vue&type=script&lang=js&"
import style0 from "./AddSource.vue?vue&type=style&index=0&id=fd353562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd353562",
  null
  
)

component.options.__file = "AddSource.vue"
export default component.exports